<template>
  <div>
    <wc-data-box
      title='Lot Size Categories'
      :loading='isLoading || isSaving'
      showAdd
      @add='add'
    >
      <v-data-table
        dense
        :items='filteredRatings'
        :headers='headers'
        :items-per-page='-1'
        hide-default-footer
        @click:row='edit'
      >
        <template v-slot:item.description='{ item }'>
          {{ item.description }} <wc-archived v-if='item.archived'></wc-archived>
        </template>
        <template v-slot:item.base_price='{ item }'>
          {{ item.base_price | decMoney }}
        </template>
        <template v-slot:item.spring_cleanup_base_price='{ item }'>
          {{ item.spring_cleanup_base_price | decMoney }}
        </template>
        <template v-slot:item.fertilizer_base_price='{ item }'>
          {{ item.fertilizer_base_price | decMoney }}
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-dialog
      title='Lot Size Category Details'
      :showDialog='showDialog'
      width='450'
      @cancel='showDialog = false'
      @save='update'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='Description'
              v-model='ratingCopy.description'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='Rating'
              :rules='[rules.decimal]'
              v-model='ratingCopy.rating'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='Time on site'
              v-model='ratingCopy.time_on_site'
              :rules='[rules.int]'
              hint='for lawn service (in minutes)'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='Lawn Service'
              v-model='ratingCopy.base_price'
              :rules='[rules.decimal]'
              hint='base price (monthly)'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='Weed Control/Fertilizer'
              v-model='ratingCopy.fertilizer_base_price'
              :rules='[rules.decimal]'
              hint='base price (for the season)'
              persistent-hint
            ></v-text-field>
          </v-col>
           <v-col cols='12' md='6'>
            <v-text-field
              label='Spring Cleanup'
              v-model='ratingCopy.spring_cleanup_base_price'
              :rules='[rules.decimal]'
              hint='base price'
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

    </wc-dialog>
  </div>
</template>

<script>
import settingsAPI from '../../api/settings'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'lawn-ratings',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isSaving: false,
    showDialog: false,
    isFormValid: false,
    ratings: [],
    ratingCopy: {},
    headers: [
      { text: 'Description', value: 'description', align: 'left' },
      { text: 'Rating', value: 'rating', align: 'center' },
      { text: 'Time on Site', value: 'time_on_site', align: 'center' },
      { text: 'Lawn Service Base Price', width: 140, value: 'base_price', align: 'end' },
      { text: 'Weed/Feed Base Price', width: 140, value: 'fertilizer_base_price', align: 'end' },
      { text: 'Spring Cleanup Base Price', width: 140, value: 'spring_cleanup_base_price', align: 'end' }
    ]
  }),
  computed: {
    filteredRatings () {
      return _.orderBy(this.ratings, 'rating')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.ratings = await settingsAPI.getRatings()
      this.isLoading = false
    },
    edit (item) {
      this.ratingCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    add () {
      this.ratingCopy = {}
      this.showDialog = true
      setTimeout(() => {
        this.$refs.form.reset()
      }, 50)
    },
    async update () {
      this.isSaving = true
      if (this.ratingCopy.id) {
        this.ratings = miscServices.replaceObject(this.ratings, await settingsAPI.updateRating(this.ratingCopy))
      } else {
        this.ratings.push(await settingsAPI.createRating(this.ratingCopy))
      }
      this.showDialog = false
      this.isSaving = false
    }
  }
}
</script>